import {
  GHAParticipationReportParams,
  GHAParticipationReportResponse,
  GHAParticipationReportRow,
  getGHAParticipationReport,
} from '~/services/PublicOfferFeedService';

import { formatCountry } from './utils';

// svc-public-offer-feed rejects a limit above 500, so bigger exports page through it.
export const EXPORT_PAGE_SIZE = 500;
export const DEFAULT_EXPORT_ROWS = 500;
// Every page is another BigQuery scan of the whole date range.
export const MAX_EXPORT_ROWS = 5000;

export const EXPORT_HEADERS = ['Property ID', 'Property name', 'Opportunities', 'User location', 'Property location'];

export type ExportQuery = Omit<GHAParticipationReportParams, 'page' | 'limit'>;

type FetchPage = (params: GHAParticipationReportParams) => Promise<GHAParticipationReportResponse>;

export function parseExportRowCount(input: string): number | null {
  const value = Number(input);
  return Number.isInteger(value) && value >= 1 && value <= MAX_EXPORT_ROWS ? value : null;
}

export async function fetchTopReportRows(
  query: ExportQuery,
  rowCount: number,
  fetchPage: FetchPage = getGHAParticipationReport,
): Promise<Array<GHAParticipationReportRow>> {
  const rows: Array<GHAParticipationReportRow> = [];
  for (let page = 0; rows.length < rowCount; page++) {
    const { result, count } = await fetchPage({ ...query, page, limit: EXPORT_PAGE_SIZE });
    rows.push(...result);
    if (result.length < EXPORT_PAGE_SIZE || rows.length >= count) {
      break;
    }
  }
  return rows.slice(0, rowCount);
}

export function toExportRecords(rows: Array<GHAParticipationReportRow>): Array<Record<string, unknown>> {
  return rows.map((row) => ({
    'Property ID': row.propertyId,
    'Property name': row.propertyName ?? '',
    Opportunities: row.opportunities,
    'User location': formatCountry(row.userCountry),
    'Property location': formatCountry(row.propertyCountry),
  }));
}

export function getExportFilename({ startDate, endDate }: ExportQuery, rowCount: number) {
  return `customer-demand_${startDate}_${endDate}_top-${rowCount}.csv`;
}
